import React, { useState } from "react";
import "../App.css";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaUser } from "react-icons/fa"; // Login icon
import img1 from "../Images/f.logo.jpg";

const CustomNavbar = () => {
  // const [loginShow, setLoginShow] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  // const handleLoginClose = () => setLoginShow(false);
  // const handleLoginShow = () => setLoginShow(true);

  const handleToggle = () => {
    setShowMobileMenu((prevState) => !prevState);
  };

  return (
    <>
      <section className="navbar-section">
        <Navbar expand="lg" className="shadow-sm fixed-top navbar-section">
          <Container>
            {/* Logo */}
            <Navbar.Brand as={Link} to="/">
              <img src={img1} alt="..." className="img-fluid" id="img1-logo" />
              <span className="navtext"> Fusionsphere.llp</span>
            </Navbar.Brand>

            {/* Toggle Button (Visible on Small Screens) */}
            <Button
              variant="light"
              className={`d-lg-none custom-toggle ${showMobileMenu ? "active" : ""}`}
              onClick={handleToggle}
            >
              ☰
            </Button>

            {/* Desktop Navbar */}
            <div className="desktop-nav">
              <Nav className="w-100 d-flex align-items-center justify-content-center">
                <Nav className="custom-nav d-flex gap-3 ms-auto">
                  <Nav.Link as={Link} to="/aboutus">About Us</Nav.Link>
                  <Nav.Link as={Link} to="/hows">How It's work</Nav.Link>
                  <Nav.Link as={Link} to="/pricing">Pricing</Nav.Link>
                  <Nav.Link as={Link} to="/case-studies">Case Studies</Nav.Link>
                  <Nav.Link as={Link} to="/reviews">Reviews</Nav.Link>
                  <Nav.Link as={Link} to="/contact">Contact</Nav.Link>
                </Nav>

                <Nav className="loginlink ms-auto d-flex align-items-center gap-3">
                  <Nav.Link as={Link} to="/get-started" variant="primary" id="getbtn">
                    Place an Order
                  </Nav.Link>
                </Nav>
              </Nav>
            </div>
          </Container>
        </Navbar>
      </section>

      {/* Mobile Menu (Only visible when showMobileMenu is true) */}
      <div
        className={`mobile-menu ${showMobileMenu ? "open" : ""}`}
        style={{
          position: "fixed",
          top: "60px", // Adjust this value based on your Navbar height
          right: "0",
          zIndex: 1000,
          backgroundColor: "#6222CC",
          width: "100%",
          maxWidth: "300px",
          height: "calc(100vh - 60px)", // Adjust height based on Navbar height
          overflowY: "auto",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          transition: "transform 0.3s ease-in-out",
          transform: showMobileMenu ? "translateX(0)" : "translateX(100%)",
      
        }}
      >
        <Nav className="flex-column p-3">
          <Nav.Link as={Link} to="/aboutus" onClick={handleToggle}>
            About Us
          </Nav.Link>
          <Nav.Link as={Link} to="/hows" onClick={handleToggle}>
            How It's work
          </Nav.Link>
          <Nav.Link as={Link} to="/pricing" onClick={handleToggle}>
            Pricing
          </Nav.Link>
          <Nav.Link as={Link} to="/case-studies" onClick={handleToggle}>
            Case Studies
          </Nav.Link>
          <Nav.Link as={Link} to="/reviews" onClick={handleToggle}>
            Reviews
          </Nav.Link>
          <Nav.Link as={Link} to="/contact" onClick={handleToggle}>
            Contact
          </Nav.Link>
          {/* <Nav.Link
            onClick={() => {
              // handleLoginShow();
              handleToggle();
            }}
            style={{ cursor: "pointer" }}
          >
            <FaUser className="me-1" /> Login
          </Nav.Link> */}
          <Button as={Link} to="/get-started" variant="primary" className="mt-2" onClick={handleToggle}>
            Place an Order Now
          </Button>
        </Nav>
      </div>

      {/* Login Modal */}
      {/* <Modal show={loginShow} onHide={handleLoginClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <FaUser className="me-2" /> Login
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Username or Email Address</Form.Label>
              <FormControl type="text" placeholder="Enter your username or email" required />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Password</Form.Label>
              <FormControl type="password" placeholder="Enter your password" required />
            </Form.Group>

            <Form.Group className="mb-3 d-flex justify-content-between">
              <Form.Check type="checkbox" label="Remember Me" />
              <Link to="/forgot-password" className="text-primary">
                Forgot Password?
              </Link>
            </Form.Group>

            <Button variant="primary" className="w-100">
              Login
            </Button>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <p className="text-center w-100">
            Don’t have an account?{" "}
            <Link to="/signup" className="text-primary">
              Sign up now
            </Link>
          </p>
        </Modal.Footer>
      </Modal> */}
    </>
  );
};

export default CustomNavbar;